import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 10l2 -2v8","key":"svg-1"}]]

const IconCircleNumber1 = createReactComponent('outline', 'circle-number-1', 'CircleNumber1', __iconNode);

export default IconCircleNumber1;